import React, { useState } from "react";
import * as Scrivito from "scrivito";
import { Button } from "components";
import { SummaryListItem } from "components/SummaryListItem";
import { useTranslate } from "hooks";

export const ProjectTreeList = Scrivito.connect(({ title, projectTree }) => {
  const translate = useTranslate();
  const [isAllCollapsed, setIsAllCollapsed] = useState(null);

  return (
    <div className="text-gray-700">
      <div className="w-100 d-flex justify-content-between align-items-center border-bottom border-dark border-2 py-2">
        <div className="ms-2 fw-bolder fs-md">{title}</div>
        <div className="d-flex flex-nowrap">
          <Button
            color="light"
            icon="plus"
            size="sm"
            classNames="me-2_5"
            onClick={() => setIsAllCollapsed(Symbol("true"))}
          >
            {translate("COLLAPSE_CONTROL_SHOW_ALL")}
          </Button>
          <Button
            color="light"
            icon="minus"
            size="sm"
            onClick={() => setIsAllCollapsed(Symbol("false"))}
          >
            {translate("COLLAPSE_CONTROL_HIDE_ALL")}
          </Button>
        </div>
      </div>
      {projectTree?.map((item) => (
        <SummaryListItem
          key={item.id}
          isAllCollapsed={isAllCollapsed}
          {...item}
        />
      ))}
    </div>
  );
});
